import styled from '@emotion/styled';
import { Icon } from '@gumtree/ui-library/src';
import { boxSizes, colors, fontSizes, gutterSizes } from '@gumtree/ui-library/src/base/theme';

export const StyledInputBlock = styled.div`
    position: relative;
    margin-bottom: ${gutterSizes.large};

    .field div {
        border: ${boxSizes.borderWidth2} solid transparent;
        border-radius: ${boxSizes.borderRadius8};
        padding: ${gutterSizes.xxsmall};

        &:focus-within {
            border: ${boxSizes.borderWidth2} solid ${colors.gtallBlue};
        }

        .button {
            display: flex;
            justify-content: center;
            width: 38px;
            height: 38px;
            box-sizing: content-box;
            padding: 0;

            .icon {
                color: ${colors.bark80};
            }
        }
    }

    & input {
        border-radius: ${boxSizes.borderRadius4};
        border-color: ${colors.bark40};
        font-size: ${fontSizes.medium};
        height: 38px;
        padding-left: 40px;
    }
`;

export const StyledFieldIcon = styled(Icon)`
    position: absolute;
    left: ${gutterSizes.medium};
    top: ${gutterSizes.medium};
    color: ${colors.bark80};
`;
